import * as actionTypes from "../actionTypes";

export function joinpathsSet(joinpaths) {
	return {
		type: actionTypes.JOINPATHS_SET,
		joinpaths,
	};
}
